import React from 'react';
import { TabsItem } from 'components/Tabs';
import Flex, { Grid } from 'components/Flex';
import ISeizures from 'interfaces/seizures';
import { CardContent } from '../../../../components/Card';
import {
  Pistol, Medicines, BoxOpen, Bullets, CarIcon,
} from '../../../../styles/icons';
import { WrapperName, LineTitle } from './styles';

interface SeizureData {
  detailSeizures:ISeizures[];
}

const SeizureDetail: React.FC<SeizureData> = ({ detailSeizures }) => {
  const detailSeizure = detailSeizures;

  return (

    <TabsItem title="Apreenções">
      <Grid container justify="flex-start" spacing={1}>
        {detailSeizure?.map((seizure:any) => (
          <Grid item key={seizure.id} xs={12} sm={12} md={12}>
            <LineTitle>
              <WrapperName>
                {seizure.seizure_type === 'Veículos' && (<><CarIcon /></>)}
                {seizure.seizure_type === 'Entorpecentes' && (<><Medicines /></>)}
                {seizure.seizure_type === 'Munições' && (<><Bullets /></>)}
                {seizure.seizure_type === 'Armas' && (<><Pistol /></>)}
                {seizure.seizure_type === 'Materiais' && (<><BoxOpen /></>)}
                &nbsp;<p>{seizure.seizure_type}</p>
              </WrapperName>
              <CardContent>
                <Grid container spacing={1}>
                  {seizure.seizure_type === 'Veículos' && (
                    <>

                      {seizure.plate ? (
                        <>
                          <Flex title="Placa" xs={12} sm={6} md={4}>
                            {seizure.plate}
                          </Flex>
                        </>
                      ) : ('')}

                      {seizure.serial ? (
                        <>
                          <Flex title="Chassi" xs={12} sm={6} md={4}>
                            {seizure.serial}
                          </Flex>
                        </>
                      ) : ('')}

                      <Flex title="Marca" xs={12} sm={6} md={4}>
                        {seizure.brand}
                      </Flex>
                      <Flex title="Modelo" xs={12} sm={6} md={4}>
                        {seizure.model}
                      </Flex>
                      <Flex title="Exercício" xs={12} sm={6} md={4}>
                        {seizure.year}
                      </Flex>
                      <Flex title="Cor" xs={12} sm={6} md={4}>
                        {seizure.color}
                      </Flex>
                    </>

                  )}

                  {seizure.seizure_type === 'Entorpecentes' && (
                    <>
                      <Flex title="Entorpecente" xs={12} sm={6} md={4}>
                        {seizure.type}
                      </Flex>
                      <Flex title="Peso (Kg)" xs={12} sm={6} md={4}>
                        {seizure.weight}
                      </Flex>
                      <Flex title="Unidades" xs={12} sm={6} md={4}>
                        {seizure.amount}
                      </Flex>
                      <Flex title="Destino" xs={12} sm={6} md={4}>
                        {seizure.destiny}
                      </Flex>
                    </>
                  )}

                  {seizure.seizure_type === 'Munições' && (
                    <>
                      <Flex title="Quantidade" xs={12} sm={6} md={4}>
                        {seizure.amount}
                      </Flex>
                      <Flex title="Calibre" xs={12} sm={6} md={4}>
                        {seizure.caliber}
                      </Flex>
                      <Flex title="Fabricante" xs={12} sm={6} md={4}>
                        {seizure.brand}
                      </Flex>
                    </>
                  )}

                  {seizure.seizure_type === 'Armas' && (
                    <>
                      <Flex title="Marca" xs={12} sm={6} md={4}>
                        {seizure.brand}
                      </Flex>
                      <Flex title="Modelo" xs={12} sm={6} md={4}>
                        {seizure.model}
                      </Flex>
                      <Flex title="Calibre" xs={12} sm={6} md={4}>
                        {seizure.caliber}
                      </Flex>
                      <Flex title="Tipo" xs={12} sm={6} md={4}>
                        {seizure.type}
                      </Flex>
                      <Flex title="Número da arma" xs={12} sm={6} md={4}>
                        {seizure.serial}
                      </Flex>
                    </>
                  )}

                  {seizure.seizure_type === 'Materiais' && (
                    <>
                      <Flex title="Quantidade" xs={12} sm={6} md={6}>
                        {seizure.amount}
                      </Flex>
                      <Flex title="Tipo" xs={12} sm={6} md={6}>
                        {seizure.type}
                      </Flex>
                      <Flex title="Marca" xs={12} sm={6} md={6}>
                        {seizure.brand}
                      </Flex>
                      <Flex title="Modelo" xs={12} sm={6} md={6}>
                        {seizure.model}
                      </Flex>
                      <Flex title="Lacre" xs={12} sm={6} md={6}>
                        {seizure.serial}
                      </Flex>
                    </>
                  )}
                  <Flex title="Relacionado" xs={12} sm={6} md={4}>
                    {seizure.involved}
                  </Flex>
                  <Flex title="Recebedor" xs={12} sm={6} md={4}>
                    {`${seizure.police} / ${seizure.registration}`}
                  </Flex>

                </Grid>
              </CardContent>
            </LineTitle>
          </Grid>

        ))}
      </Grid>
    </TabsItem>

  );
};

export default SeizureDetail;
